import { api } from "..";

import { QueryProps } from "@/types/Api";
import { CreditFeature, CreditTier } from "@/types/CreditTier";

export interface GetCreditTierQueryParams {
  id: number;
  feature: CreditFeature;
}

export const getCreditTier = async (
  props: QueryProps<GetCreditTierQueryParams>
): Promise<CreditTier> => {
  const res = await api.client.get(`/credit-tiers/${props.params.id}`, {
    signal: props.signal,
    params: { feature: props.params.feature },
  });
  return res.data;
};
